import ParametroService from "../domain/web/ParametroService.js";

function initialState() {
  return {
    aluno: null,
    matricula: null,
    rematricula: null,
    parametros: {},
    mensagens: {
      choqueHorario:
        "Você deve eliminar os choques de horários antes de prosseguir.",
      choqueHorarioToast: "Choque de Horário! Verifique o quadro de horários.",
      inclusaoBloqueada:
        "A inclusão de disciplinas está indisponível neste processo.",
      remocaoBloqueada:
        "A remoção de disciplinas está indisponível neste processo.",
      remocaoDisciplinaBloqueada:
        "A remoção dessa disciplina está indisponível neste processo.",
      alteracaoIndisponivel:
        "Você está retido e não poderá fazer alterações em sua matrícula.",
      inconsistenciaValor: "Existem disciplinas sem valor configurado:",
      choqueHorarioPemitido:
        "Existem disciplinas com choque de horário. Estas disciplinas só estarão disponíves após serem aprovadas pelo coordenador do seu curso.",
      inclusaoBloqueadaVagas:
        "A inclusão dessa disciplina está indisponível por falta de vagas."
    }
  };
}

const mutations = {
  updateAluno(state, aluno) {
    state.aluno = aluno;
  },
  updateMatricula(state, matricula) {
    state.matricula = matricula;
  },
  updateRematricula(state, rematricula) {
    state.rematricula = rematricula;
  },
  updateParametros(state, parametros) {
    state.parametros = parametros;
  },
  clearStorage(state) {
    const s = initialState();

    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  }
};

const actions = {
  setAluno(state, aluno) {
    state.commit("updateAluno", aluno);
  },
  setMatricula(state, matricula) {
    state.commit("updateMatricula", matricula);
  },
  setRematricula(state, rematricula) {
    state.commit("updateRematricula", rematricula);
  },
  resetState(state) {
    state.commit("clearStorage");
  },

  async fetchParametrosSistema({ commit }, resource) {
    try {
      const parametroService = new ParametroService(resource);

      const chavesNecessarias = [
        "REMATRICULA_CHOQUE_QTD",
        "REMATRICULA_CHOQUE_PERC"
      ];

      const parametros = await parametroService.getParametrosByChave(
        chavesNecessarias
      );

      commit("updateParametros", parametros);
    } catch (error) {
      console.error("Erro ao buscar parâmetros do sistema:", error);
      commit("updateParametros", {
        REMATRICULA_CHOQUE_QTD: 2,
        REMATRICULA_CHOQUE_PERC: 0.25
      });
    }
  }
};

const namespaced = true;

const alteracaoMatricula = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default alteracaoMatricula;



// WEBPACK FOOTER //
// ./src/store/alteracaoMatricula.js